export const WIZARD_BUTTONS = [
    {
        name: "login",
        title: "start"
    },
    {
        name: "auth",
        title: "auth"
    },
    {
        name: "report",
        title: "report"
    },
]